export default "__VITE_ASSET__55f6df59__"